import { IconProps } from '../Icon';
import { TextProps } from '../Text';


type ButtonInternalProps = {
  icon?: IconProps;
  text?: TextProps;
};

type ButtonPropsValues = {
  'IconTextMedium': ButtonInternalProps;
  'IconTextSmall': ButtonInternalProps;
  'IconTextTextExtraSmall': ButtonInternalProps;
  'IconTextTextSmall': ButtonInternalProps;
  'TextIconTextMedium': ButtonInternalProps;
  'TextIconTextSmall': ButtonInternalProps;
  'TextIconTextUnderlineSmall': ButtonInternalProps;
  'TextContainedGreenLarge': ButtonInternalProps;
  'TextContainedGreenMedium': ButtonInternalProps;
  'TextContainedLarge': ButtonInternalProps;
  'TextContainedMedium': ButtonInternalProps;
  'TextContainedSmall': ButtonInternalProps; // MANUAL OVERRIDE
  'TextContainedExtraSmall': ButtonInternalProps; // MANUAL OVERRIDE
  'TextContainedWhiteMedium': ButtonInternalProps;
  'TextContainedWhiteLarge': ButtonInternalProps; // MANUAL OVERRIDE
  'TextOutlinePillMedium': ButtonInternalProps;
  'TextOutlineMedium': ButtonInternalProps;
  'TextOutlineSmall': ButtonInternalProps;
  'TextTextDarkMedium': ButtonInternalProps;
  'TextTextGreySmall': ButtonInternalProps;
  'TextTextMedium': ButtonInternalProps;
  'TextTextSmall': ButtonInternalProps;
  'TextTextWhiteMedium': ButtonInternalProps;
  'TextTextWhiteSmall': ButtonInternalProps;
  'TextTextLarge': ButtonInternalProps; // MANUAL OVERRIDE
  'TextTextUnderlineSmall': ButtonInternalProps; // MANUAL OVERRIDE
};

const propValues: ButtonPropsValues = {
  'IconTextMedium': {
    icon: {
      asset: 'CloseCircle',
      style: 'White',
    },
  },
  'IconTextSmall': {
    icon: {
      asset: 'Search',
      style: 'White',
    },
  },
  'IconTextTextExtraSmall': {
    icon: {
      asset: 'ChevronLeft',
      style: 'ActionBase',
    },
    text: {
      type: 'Body',
      size: 'Medium',
      style: 'Regular',
      colour: 'ActionBase',
      align: 'Left',
    },
  },
  'IconTextTextSmall': {
    icon: {
      asset: 'ChevronLeft',
      style: 'ActionBase',
    },
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'ActionActive',
      align: 'Left',
    },
  },
  'TextIconTextMedium': {
    text: {
      type: 'Decoration',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    icon: {
      asset: 'ChevronDown',
      style: 'ActionHover',
    },
  },
  'TextIconTextSmall': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'ActionHover',
      align: 'Left',
    },
    icon: {
      asset: 'ChevronDown',
      style: 'ActionHover',
    },
  },
  'TextIconTextUnderlineSmall': {
    text: {
      type: 'Decoration',
      size: 'Medium',
      style: 'Regular',
      colour: 'ActionHover',
      align: 'Left',
    },
    icon: {
      asset: 'ChevronDown',
      style: 'ActionHover',
    },
  },
  'TextContainedGreenLarge': {
    text: {
      type: 'Subheading',
      size: 'Medium',
      style: 'Regular',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  'TextContainedGreenMedium': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'SemiBold',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  'TextContainedLarge': {
    text: {
      type: 'Subheading',
      size: 'Medium',
      style: 'Regular',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  'TextContainedMedium': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'SemiBold',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  // MANUAL OVERRIDE STARTS
  'TextContainedSmall': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'ActionBase',
      align: 'Right',
    },
  },
  'TextContainedExtraSmall': {
    text: {
      type: 'Body',
      size: 'Medium',
      style: 'Regular',
      colour: 'Action',
      align: 'Left',
    },
  },
  'TextContainedWhiteLarge': {
    text: {
      type: 'ButtonText',
      size: 'Medium',
      style: 'Regular',
      colour: 'ActionBase',
      align: 'Left',
    },
  },
  // MANUAL OVERRIDE ENDS
  'TextContainedWhiteMedium': {
    text: {
      type: 'Body',
      size: 'Medium',
      style: 'Regular',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  'TextOutlinePillMedium': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'ActionBase',
      align: 'Left',
    },
  },
  'TextOutlineMedium': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'ActionBase',
      align: 'Left',
    },
  },
  'TextOutlineSmall': {
    text: {
      type: 'Body',
      size: 'Medium',
      style: 'Regular',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  'TextTextDarkMedium': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'SemiBold',
      colour: 'SubduedDark',
      align: 'Left',
    },
  },
  'TextTextGreySmall': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedLight',
      align: 'Left',
    },
  },
  'TextTextMedium': {
    text: {
      type: 'Subheading',
      size: 'Medium',
      style: 'Regular',
      colour: 'ActionBase',
      align: 'Left',
    },
  },
  'TextTextSmall': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'ActionBase',
      align: 'Left',
    },
  },
  'TextTextWhiteMedium': {
    text: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  'TextTextWhiteSmall': {
    text: {
      type: 'Body',
      size: 'Large', // MANUAL OVERRIDE
      style: 'Regular',
      colour: 'BaseLight',
      align: 'Left',
    },
  },
  'TextTextLarge': { // MANUAL OVERRIDE
    text: {
      type: 'Body',
      size: 'Large',
      style: 'SemiBold',
      colour: 'SubduedDark',
      align: 'Left',
    },
  },
  'TextTextUnderlineSmall': { // MANUAL OVERRIDE
    text: {
      type: 'Body',
      size: 'Small',
      style: 'SemiBold',
      colour: 'SubduedDark',
      align: 'Left',
    },
  },
};

const getProps = (type: string): ButtonInternalProps => {
  const values: ButtonInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
